/*
Per la logica usata nei selectors si veda
https://redux.js.org/usage/deriving-data-selectors
e
https://react-redux.js.org/api/hooks
*/

import {
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';

import { RootState } from '../../app/store';

export interface UserState {
  userFavorites: string[];
}

const initialState: UserState = {
  userFavorites: (() => {
    if (typeof localStorage !== 'undefined') {
      try {
        const storedFavorites = localStorage.getItem('userFavorites');
        return storedFavorites ? JSON.parse(storedFavorites) : [];
      } catch (e) {
        console.error('Errore nel parsing dei preferiti dal localStorage');
        return [];
      }
    }
    return [];
  })(),
};

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUserFavorites: (state, action: PayloadAction<string>) => {
      const isLocalStorageAvailable = typeof localStorage !== 'undefined';
      
      let storedFavorites: string[] = [];
      if (isLocalStorageAvailable) {
        const storedFavoritesString = localStorage.getItem('userFavorites');
        if (storedFavoritesString) {
          try {
            storedFavorites = JSON.parse(storedFavoritesString);
          } catch (e) {
            console.error('Errore nel parsing dei preferiti dal localStorage');
          }
        }
      }
  
      if (state.userFavorites.length === 0 && storedFavorites.length > 0) {
        state.userFavorites = storedFavorites;
      }
      
      let newFavoritesArray = state.userFavorites.includes(action.payload)
        ? state.userFavorites.filter((favorite) => favorite !== action.payload)
        : [...state.userFavorites, action.payload];
      
      state.userFavorites = newFavoritesArray;
      
      if (isLocalStorageAvailable) {
        localStorage.setItem('userFavorites', JSON.stringify(newFavoritesArray));
      }
    },
  },
});

export const {
  setUserFavorites,
} = usersSlice.actions;

export const selectUserFavorites = (state: RootState) =>
  state.users.userFavorites;

export default usersSlice.reducer;
